<style lang="less" scoped>
    .modal {
        /deep/.ivu-modal-body {
        //     min-height: 0;
        }
    }
</style>
<template>
  <div>
    <Modal
      v-model="showModal"
      class="modal"
      title="上传附件/备注"
      :closable="false"
    >
      <div>
        <Form
          ref="formValidate" 
          :model="formItem"
          :label-width="80"
        >
          <FormItem 
            label="备注"
          >
            <Input
              v-model="formItem.examine_remark"
              type="textarea"
              :autosize="{minRows: 3,maxRows: 5}"
              placeholder="请输入"
            />
          </FormItem>
          <FormItem 
            label="附件"
          >
            <EditAttachments
              :files="formItem.bfiles"
              model_type="FileStamp"
              :model_id="formItem.id"
            ></EditAttachments>
            <FileUploader @uploaded="attachmentUploaded"></FileUploader>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="loading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
    import FileUploader from '../../components/file/uploader';
    import EditAttachments from '../../components/file/edit_attachments'
    export default {
        components: {
            FileUploader,
            EditAttachments
        },
        props: {
            display: {
                type: Number,
                default:() => null
            },
            formProps: {
              type:Object,
              default:() => ({})
            },
            loading:{
                type:Boolean,
                default:() => false
            }
        },
        data () {
            return {
                showModal: false,
                title: '',
                formItem: {
                    id:null,
                    examine_remark: '',
                    bfiles:[],
                }
            }
        },
        watch: {
            display (value) {
                if(value===1) {
                    this.formItem = {
                        id: this.formProps.id,
                        examine_remark: this.formProps.examine_remark,
                        bfiles: [...this.formProps.bfiles]
                    }
                    this.showModal = true
                } else {
                    this.formItem= {
                        id:null,
                        examine_remark: '',
                        bfiles:[],
                    }
                }
            }
        },
        methods: {
            attachmentUploaded (file) {
                this.formItem.bfiles.push(file)
            },
            ok () {
                const { id } = this.formProps
                const { examine_remark,bfiles } = this.formItem
                this.$emit('ok',{ id,examine_remark,bfiles:bfiles.map(item => ({id:item.id})),call:() => this.showModal = false }) 
            },
            cancel () {
                this.showModal = false
                this.$emit('cancel')
            }
        }
    }
</script>
